import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import WarningIcon from '@mui/icons-material/Warning'

import authHook from '@hooks/useAuth'
import chatHook from '@hooks/useChat'
import dialogHook from '@hooks/useDialog'
import navigationHook from '@hooks/useNavigation'
import titleHook from '@hooks/useTitle'

import { TLGDialog } from '@components/Dialog'
import { StandardPlans } from '@components/StandardPlans'

import { UserType } from '@utils/types'

import { dialogIconSx, dialogSx, wrapperSx } from './styles'

import { HeroSection } from './components/HeroSection'

const TechVendorsPricing = () => {
  const { t } = useTranslation()
  const { setIsShowAssistanceChatBubble } = chatHook.useChat()
  const { isVendor } = authHook.useAuth()
  const { navigateTo } = navigationHook.useNavigation()

  titleHook.useTitle(t('Technology Match - Tech Vendors - Pricing'))

  const signDialog = dialogHook.useDialog()

  useEffect(() => {
    setIsShowAssistanceChatBubble(true)
  }, [setIsShowAssistanceChatBubble])

  const handleOnPlanClick = () => {
    if (isVendor()) {
      navigateTo({ path: '/vendor/settings' })
      return
    }

    signDialog.open()
  }

  const handleCreateAnAccountClick = () => {
    navigateTo({ path: `/signup#${UserType.VENDOR}` })
  }

  const handleIAlreadyHaveClick = () => {
    navigateTo({ path: `/signin#${UserType.VENDOR}` })
  }

  return (
    <>
      <TLGDialog
        open={signDialog.isOpen}
        icon={<WarningIcon sx={dialogIconSx} />}
        title={t("You're not signed in")}
        text={t(
          'To subscribe to our plans, you need to have a vendor account with The Launchpad. Do you already have one?'
        )}
        button1={{
          text: t('Create an account'),
          props: {
            variant: 'text',
          },
          onClick: handleCreateAnAccountClick,
        }}
        button2={{
          text: t('I already have'),
          props: {
            variant: 'contained',
          },
          onClick: handleIAlreadyHaveClick,
        }}
        onClose={signDialog.close}
        containerSx={dialogSx}
      />

      <Box sx={wrapperSx}>
        <HeroSection />
        <StandardPlans onPlanClick={handleOnPlanClick} />
      </Box>
    </>
  )
}

export { TechVendorsPricing }
